import { IfcStoreyAssignment } from '@editor/components/Controls/IFCUploadWidget/types/ifcMetadata'

/** Distinct swatch colors cycled per storey for the IFC storey coloring. */
export const STOREY_COLOR_PALETTE = [
  '#1e88e5',
  '#43a047',
  '#e53935',
  '#fb8c00',
  '#8e24aa',
  '#00acc1',
  '#fdd835',
  '#6d4c41',
  '#3949ab',
  '#c0ca33',
]

/** Assign a palette color to each storey (by its position in the list). */
export const getStoreyColorByStorey = (storeys: string[]): Record<string, string> =>
  storeys.reduce((acc, storey, index) => {
    acc[storey] = STOREY_COLOR_PALETTE[index % STOREY_COLOR_PALETTE.length]
    return acc
  }, {} as Record<string, string>)

/** Map each storey-assigned IFC element guid to its storey's color. */
export const getGuidToStoreyColor = (
  storeyAssignments: IfcStoreyAssignment[][],
  storeyColorByStorey: Record<string, string>,
): Record<string, string> => {
  const map: Record<string, string> = {}
  storeyAssignments.forEach(group => {
    group.forEach(({ elementId, storey }) => {
      const color = storeyColorByStorey[storey]
      if (color) map[elementId] = color
    })
  })
  return map
}

/** Group the assigned IFC element guids by storey. */
export const getStoreyToGuidSet = (
  storeyAssignments: IfcStoreyAssignment[][],
): Record<string, Set<string>> => {
  const out: Record<string, Set<string>> = {}
  storeyAssignments.forEach(group => {
    group.forEach(({ elementId, storey }) => {
      if (!out[storey]) out[storey] = new Set()
      out[storey].add(elementId)
    })
  })
  return out
}
